import { definePreset, palette } from '@primeuix/themes'
import Aura from '@primeuix/themes/aura'
import type { AuraBaseDesignTokens } from '@primeuix/themes/aura/base'
import type { Preset } from '@primeuix/themes/types'
import type { ColumnPassThroughMethodOptions } from 'primevue/column'
import PrimeVue, { type PrimeVueConfiguration } from 'primevue/config'
import type { App } from 'vue'
import { getLocalDateFormat } from './formatters'
import { CustomTooltipDirective } from './primevue-tooltip-directive'

// https://ossovr.atlassian.net/wiki/spaces/NT/pages/3422781449/2D+Design+Principles
const beanRed = palette('#e85f5c')
const amethyst = palette('#9063cd')
const greyTeal = palette('#5e9f7e')
const saffronMango = palette('#f7c75d')

const preset = definePreset(Aura, {
  primitive: {
    red: beanRed,
    orange: saffronMango,
    green: greyTeal
  },
  semantic: {
    primary: amethyst,
    colorScheme: {
      light: {
        mask: {
          background: 'rgba(0, 0, 0, 0.1)'
        }
      }
    }
  }
} as Preset<AuraBaseDesignTokens>)

export function columnDataTestId(options: ColumnPassThroughMethodOptions) {
  return options?.props?.field
    ? {
        'data-testid': `td-${options.props.field as string}`
      }
    : {}
}

const localDateFormat = getLocalDateFormat()
const primeVueConfig: PrimeVueConfiguration = {
  // @ts-expect-error: Missing properties will default which is desired behavior
  locale: {
    dateFormat: localDateFormat
  },
  theme: {
    preset,
    options: {
      darkModeSelector: 'none'
    }
  },
  pt: {
    datatable: {
      // Primevue typing sucks
      // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
      bodyRow: ({ props }: any) => ({ 'data-testid': `tr-${props.rowData.id}` })
    },
    column: {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-argument
      bodyCell: (x: any) => columnDataTestId(x.column)
    }
  }
}

export function configurePrimeVue(app: App<Element>) {
  app.use(PrimeVue, primeVueConfig).directive('tooltip', CustomTooltipDirective)
}

export const colors = {
  amethyst
}
